module.exports = __webpack_public_path__ + "static/media/REP-logo.3efc2ab6.png";